import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from 'shared/context/AuthContext';
import { NotificacionesProvider } from 'shared/context/NotificacionesContext';
import API, { getImagenUrl } from 'shared/api';
import { esSubdominioReservado } from 'shared/config';
import ClienteHome from './pages/ClienteHome';
import LandingPage from './pages/LandingPage';
import BotIADetalle from './pages/detalle/BotIADetalle';
import PedidosDetalle from './pages/detalle/PedidosDetalle';
import InventarioDetalle from './pages/detalle/InventarioDetalle';
import RoadmapDetalle from './pages/detalle/RoadmapDetalle';
import PreciosDetalle from './pages/detalle/PreciosDetalle';
import RegistroEmpresa from './pages/RegistroEmpresa';
import MesaPedido from './pages/MesaPedido';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function EmpresaLoader({ slug }) {
  const [config, setConfig] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    localStorage.setItem('agorax_empresa_slug', slug);
    API.get(`/publico/empresa-config?slug=${slug}`)
      .then((res) => {
        const cfg = res.data.data;
        setConfig(cfg);
        document.title = cfg.nombre || 'Agorax';

        const favicon = document.getElementById('dynamic-favicon');
        if (favicon) {
          if (cfg.logo_url) {
            const logoFull = getImagenUrl(cfg.logo_url);
            favicon.href = logoFull;
          } else {
            favicon.href = `${process.env.PUBLIC_URL || ''}/logo-agorax.jpeg`;
          }
        }
        const root = document.documentElement;
        root.style.setProperty('--color-primary', cfg.color_primario || '#0B1A4A');
        root.style.setProperty('--color-secondary', cfg.color_secundario || '#2952CC');
        root.style.setProperty('--color-bg', cfg.color_fondo || '#F5F7FA');
        root.style.setProperty('--color-success', cfg.color_exito || '#34a853');
        root.style.setProperty('--color-danger', cfg.color_peligro || '#ea4335');
        root.style.setProperty('--color-surface', '#FFFFFF');
        root.style.setProperty('--color-border', '#E8EAEF');
        root.style.setProperty('--color-text', '#202124');
        root.style.setProperty('--color-text-secondary', '#7A869A');
        root.style.setProperty('--color-text-muted', '#A0A8B4');
        root.style.setProperty('--color-bg-hover', '#F0F1F5');
        root.style.setProperty('--color-danger-light', '#fce8e6');

        const appName = cfg.nombre_app || cfg.nombre || 'Agorax';
        const color = cfg.color_primario || '#0B1A4A';
        const metaTheme = document.querySelector('meta[name="theme-color"]');
        if (metaTheme) metaTheme.setAttribute('content', color);
        const metaAppleTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]');
        if (metaAppleTitle) metaAppleTitle.setAttribute('content', appName);
        const manifestLink = document.querySelector('link[rel="manifest"]');
        if (manifestLink)
          manifestLink.setAttribute(
            'href',
            `${process.env.REACT_APP_API_URL || ''}/publico/manifest?slug=${cfg.slug}`
          );
      })
      .catch(() => setError('Empresa no encontrada'));
  }, [slug]);

  if (error) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          fontFamily: 'sans-serif',
          fontSize: '18px',
          color: '#666',
        }}
      >
        {error}
      </div>
    );
  }
  if (!config) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          fontFamily: 'sans-serif',
        }}
      >
        Cargando...
      </div>
    );
  }
  return <ClienteHome config={config} />;
}

function App() {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  const isMainDomain = parts.length <= 2 || esSubdominioReservado(parts[0]);
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

  if (isLocalhost) {
    return (
      <AuthProvider>
        <BrowserRouter>
          <NotificacionesProvider>
            <ScrollToTop />
            <Routes>
              <Route path="/registro" element={<RegistroEmpresa />} />
              <Route path="/*" element={<ClienteHome config={null} />} />
            </Routes>
          </NotificacionesProvider>
        </BrowserRouter>
      </AuthProvider>
    );
  }

  if (isMainDomain) {
    return (
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/detalle/bot-ia" element={<BotIADetalle />} />
          <Route path="/detalle/pedidos" element={<PedidosDetalle />} />
          <Route path="/detalle/inventario" element={<InventarioDetalle />} />
          <Route path="/detalle/roadmap" element={<RoadmapDetalle />} />
          <Route path="/detalle/precios" element={<PreciosDetalle />} />
          <Route path="/registro" element={<RegistroEmpresa />} />
          <Route path="/*" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    );
  }

  const slug = parts[0];

  return (
    <AuthProvider>
      <BrowserRouter>
        <NotificacionesProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/mesa/:token" element={<MesaPedido slug={slug} />} />
            <Route path="/*" element={<EmpresaLoader slug={slug} />} />
          </Routes>
        </NotificacionesProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
